import { Card, CardBody, Col, Table } from "reactstrap";
import DashboardCommonHeader from "../../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { H5, Image, P } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";
import { ActivitiesData } from "../../../../../Data/General/Dashboard/Default";
import { Link } from "react-router-dom";
import { ActivitiesTitle } from "../../../../../Constants/Constants";

const Activities = () => {
  return (
    <Col xl="4" md="6">
      <Card className="activity-review">
        <DashboardCommonHeader title={ActivitiesTitle} dropdownClass="dropdown-toggle" />
        <CardBody>
          <Table className="table-bordernone">
            <tbody>
              {ActivitiesData.map((item, index) => (
                <tr key={index}>
                  <td>
                    <div className="d-flex gap-2">
                      <Image className="img-fluid" src={dynamicImage(item.image)} alt="" />
                      <div className="flex-grow-1">
                        <Link to={`${process.env.PUBLIC_URL}/applications/to_do`}><H5>{item.title}</H5></Link>
                        <P>{item.time}</P>
                      </div>
                      <div className="time-badge">
                        <P>{item.date}</P>
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Activities;
